import { render, staticRenderFns } from "./DeleteConfirmation.vue?vue&type=template&id=f118f26c&"
import script from "./DeleteConfirmation.vue?vue&type=script&lang=js&"
export * from "./DeleteConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports